
















































































import { Vue, Component } from "@/shared/vuepack";
import { Validator } from "vee-validate";
import Button from "@/shared/components/ui/Button.vue";
import LoginWrapper from "@/shared/components/ui/LoginWrapper.vue";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import { OktaSignInWidgetBuilder } from "@/shared/oktaSignInWidgetWrapper";
import { useNotifierStore } from "@/shared/store/notifier";
import { useUserStore } from "@/shared/store/user";
import { useSignUpStore } from "@/employee/store/signup";
import { LoginRouteNames } from "@/shared/loginRoutes";
import { useThemeStore } from "@/shared/store/theme";
import HsaBankOnboardingFooter from "@/employee/components/shared/HsaBankOnboardingFooter.vue";

@Component({
  components: {
    HsaBankOnboardingFooter,
    Button,
    LoginWrapper,
    GenericLoadingSpinner
  }
})
export default class LoginInfo extends Vue {
  $validator: Validator;
  signupStore = useSignUpStore();
  notifierStore = useNotifierStore();
  userStore = useUserStore();
  themeStore = useThemeStore();

  isProcessing = false;
  password = "";
  confirmPassword = "";
  username = "";
  showStartOverButton = false;
  widget = new OktaSignInWidgetBuilder("#okta-signin-container-auto-login");

  get submitDisabled () {
    return this.isProcessing;
  }
  get invalidState (): boolean {
    return !this.signupStore.isEmailVerified || this.signupStore.bendUserId === "" || this.signupStore.bendUserId === undefined;
  }
  get confirmPasswordValidation () {
    return {
      required: !!this.password,
      confirmed: !!this.confirmPassword && this.password
    };
  }
  onSubmit () {
    this.isProcessing = true;
    this.showStartOverButton = false;
    this.$validator.validateAll()
    .then(isValid => {
      if (!isValid) {
        this.isProcessing = false;
        return;
      }
      return this.submitCreateLoginRequest();
    })
    .catch(() => {
      this.isProcessing = false;
      this.showStartOverButton = true;
    });
  }
  submitCreateLoginRequest () {
    return this.signupStore.individualSignupCreateLogin({
      bendUserId: this.signupStore.bendUserId,
      signature: this.signupStore.signature,
      username: this.username,
      password: this.confirmPassword
    }).then(() => this.signIn());
  }
  signIn () {
    this.widget
    .buildForLoginWithoutPrompt(this.username, this.password)
    .showSignInAndSetTokens()
    .then(() => this.userStore.postLogin())
    .catch(() => {
      this.isProcessing = false;
      this.userStore.logout();
      this.userStore.setLoginUsername(this.username);
      this.$router.push({ name: LoginRouteNames.OktaLogin });
      this.notifierStore.setDanger("Unable to login, please try again");
    });
  }
  togglePasswordMask (inputId: string) {
    const passwordField = document.getElementById(inputId);
    if (passwordField.getAttribute("type") === "password") {
      passwordField.setAttribute("type", "text");
    } else {
      passwordField.setAttribute("type", "password");
    }
  }
  destroyed () {
    this.widget.destroyed();
  }
}
